import { render, staticRenderFns } from "./TabPreview.vue?vue&type=template&id=ee6d2f76"
import script from "./TabPreview.vue?vue&type=script&setup=true&lang=js"
export * from "./TabPreview.vue?vue&type=script&setup=true&lang=js"
import style0 from "./TabPreview.vue?vue&type=style&index=0&id=ee6d2f76&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports